import {
    ADD_AREA_START,
    ADD_AREA_SUCCESS,
    ADD_AREA_ERROR
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.add, action = {type: ''}) => {
    switch (action.type) {
        case ADD_AREA_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case ADD_AREA_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case ADD_AREA_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/addAreaReducer.js